import { allowedFileTypes } from '../tools/utils';
import * as yup from 'yup';

const getRequiredMessage = (field: string) => `The ${field} field is required`;
const checkMaxAllowedInMb = (value: number, maxValue: number = 1000000) => !(value / maxValue > 1);
export const CADSchema = yup.object().shape({
    make: yup.string().trim().required(getRequiredMessage('Make')),
    model: yup.string().trim().required(getRequiredMessage('Model')),
    serialNumber: yup.string().trim().required(getRequiredMessage('SerialNumber')),
    maxRelatedCapacity: yup.number().required("maxRatedCapacity is required").test('not-zero', 'Value must not be zero', value => value !== 0),
    boomLength: yup.number().required(getRequiredMessage('Boomlength')).typeError('boomLength must be a whole number')
        .when('craneType', {
            is: (craneType: string) => craneType === 'TSS' || craneType === 'TLL',
            then: yup.number().integer('boomLength must be a whole number').required(getRequiredMessage('Boomlength')).typeError('boomLength must be a whole number')
        }),
    isBoomTruck: yup.string()
        .when('craneType', {
            is: (craneType: string) => craneType === 'TSS' || craneType === 'TLL',
            then: yup.string().test('select-boom', getRequiredMessage('Is boomtruck'), value => value !== 'default'),
        }),


    workingArea: yup.string()
        .when('craneType', {
            is: (cranType: string) => cranType === 'TSS' || cranType === 'TLL',
            then: yup.string().test('select-workingArea', getRequiredMessage('Working area'), value => value !== 'default')
        }),
    cranePosition: yup.string()
        .when('craneType', {
            is: (cranType: string) => cranType === 'TSS' || cranType === 'TLL',
            then: yup.string().test('select-cranePosition', getRequiredMessage('craneMountPosition'), value => value !== 'default')
        }),
    truckBedLength: yup.number()
        .when('craneType', {
            is: (cranType: string) => cranType === 'TSS' || cranType === 'TLL',
            then: yup.number().integer('truckBedLength must be a whole number').required(getRequiredMessage('truckBedLength')).typeError('truckBedLength must be a whole number')
        }),

    frontOutrigger: yup.mixed().optional(),
    backOutrigger: yup.mixed().optional(),
    ropeSizeType: yup.mixed().optional(),
    allowableLine: yup.number().integer('allowableLine must be a whole number').required(getRequiredMessage('allowableLine')).typeError('allowableLine must be a whole number'),
    diameterTestWeight: yup.number()
        .integer('diameterTestWeight must be a whole number')
        .required(getRequiredMessage('diameterTestWeight'))
        .typeError('diameterTestWeight must be a whole number'),

    remoteControl: yup.string().required(getRequiredMessage('remote control')),
    cadNotes: yup.string().optional(),
    loadChart: yup.mixed().required(getRequiredMessage('load Chart'))
        .test('fileSize', 'The file is too large (Max 5 MB)', (value: any) => {
            if (value) {
                return checkMaxAllowedInMb(value.size, 5000000);
            }

            return true;
        }).test('fileType', 'File type not supported.', (value: any) => {
            if (allowedFileTypes.indexOf(value?.type) === -1) {
                return false;
            }
            return true;
        }),
    linePullChart: yup
        .mixed()
        .required(getRequiredMessage('line pull chart'))
        .test('fileSize', 'The file is too large (Max 5 MB)', (value: any) => {
            if (value) {
                return checkMaxAllowedInMb(value.size, 5000000);
            }

            return true;
        }).test('fileType', 'File type not supported.', (value: any) => {
            if (allowedFileTypes.indexOf(value?.type) === -1) {
                return false;
            }
            return true;
        }),
    rangeDiagram: yup
        .mixed()
        .required(getRequiredMessage('range diagram'))
        .test('fileSize', 'The file is too large (Max 5 MB)', (value: any) => {
            if (value) {
                return checkMaxAllowedInMb(value.size, 5000000);
            }

            return true;
        }).test('fileType', 'File type not supported.', (value: any) => {
            if (allowedFileTypes.indexOf(value?.type) === -1) {
                return false;
            }
            return true;
        }),
    Zip: yup.string().trim().required(getRequiredMessage('Zip')),
    City: yup.string().trim().required(getRequiredMessage('City')),
    FirstName: yup.string().trim().required(getRequiredMessage('First Name')),
    LastName: yup.string().trim().required(getRequiredMessage('Last Name')),
    Address: yup.string().trim().required(getRequiredMessage('Address')),
    State: yup.string().trim().required(getRequiredMessage('State')),
    BillToEmail: yup.string().trim().email('Invalid email').required(getRequiredMessage('Email')),
    BillingPhone: yup.string().trim().required(getRequiredMessage('phone')),
    BillingCountry: yup.string().trim().required(getRequiredMessage('country')),
})
